/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import { SectionHeadingMed } from '../../../Components/Headings';
import CardWithHeaderImage from '../../../Components/Card/cardWithHeaderImage/CardWithHeaderImage';
import cardImage1 from '../../../assets/images/png/health.png';
import cardImage2 from '../../../assets/images/png/beauty.png';
import cardImage3 from '../../../assets/images/png/nutrition.png';
import cardImage4 from '../../../assets/images/png/fitness.png';
import './popularTopics.css';

function PopularTopics() {
  const cardDatas = [
    {
      image: cardImage1,
      topic: 'Health',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      btnText: 'explore topic'
    },
    {
      image: cardImage2,
      topic: 'Beauty',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      btnText: 'explore topic'
    },
    {
      image: cardImage3,
      topic: 'Nutrition',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      btnText: 'explore topic'
    },
    {
      image: cardImage4,
      topic: 'Fitness',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      btnText: 'explore topic'
    }
  ];

  return (
    <section className="popularTopics">
      <Container>
        <SectionHeadingMed text="Popular Topics" />
        <Row>
          {cardDatas.map((cardData, index) => (
            <Col md={3} key={index}>
              <CardWithHeaderImage {...cardData} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default PopularTopics;
